// EXEMPT
import { appURLs } from "@/app/app-urls.mjs";
import type { GameDefinition } from "@/app/game-definition.mjs";
import GameIconBox2xko from "@/inline-assets/game-icon-box-2xko.svg";
import GameIconBoxRust from "@/inline-assets/game-icon-box-rust.svg";
import GameIconShape2xko from "@/inline-assets/game-icon-shape-2xko.svg";
import GameIconShapeRust from "@/inline-assets/game-icon-shape-rust.svg";
import symbolName from "@/util/symbol-name.mjs";

const dummySettings = () => Promise.resolve({ default: () => null });

export const GAME_SYMBOL_2XKO: unique symbol = symbolName("2xko");
export const Game2xko = {
  gameSymbol: GAME_SYMBOL_2XKO,
  friendlyName: ["common:games.2xko.short", "2XKO"],
  fullName: ["common:games.2xko.long", "2XKO"],
  shortName: "2xko" as const,
  gameColor: "#CDF564",

  // TODO: update from default icons
  iconShape: GameIconShape2xko,
  iconBox: GameIconBox2xko,
  icon: "", // TODO: update me
  imageKeyart: `${appURLs.CDN}/blitz/ui/img/game-cover/2xko-min.webp`,

  isActive: false,
  preferFriendlyName: false as const,

  settings: dummySettings,
  navLinks: [],
  routes: [],
} satisfies GameDefinition<typeof GAME_SYMBOL_2XKO>;

export const GAME_SYMBOL_RUST: unique symbol = symbolName("rust");
export const GameRust = {
  gameSymbol: GAME_SYMBOL_RUST,
  friendlyName: ["common:games.rust.short", "Rust"],
  fullName: ["common:games.rust.long", "Rust"],
  shortName: "rust" as const,
  gameColor: "#CD412B",

  iconShape: GameIconShapeRust,
  iconBox: GameIconBoxRust,
  icon: "", // TODO: update me
  imageKeyart: `${appURLs.CDN}/blitz/ui/img/game-cover/rust-min.webp`,

  isActive: false,
  preferFriendlyName: false as const,

  settings: dummySettings,
  navLinks: [],
  routes: [],
} satisfies GameDefinition<typeof GAME_SYMBOL_RUST>;
